<template>
  <div>
    <p class="text-caption grey--text">
      Al continuar estoy aceptando la
      <span class="text--primary font-weight-medium" @click="dialog = true" style="cursor: pointer;">
        política de privacidad
      </span>
      de pagos en línea.
    </p>

    <v-dialog v-model="dialog" max-width="600px">
      <v-card>
        <v-card-title class="headline font-weight-bold">
          Política de Privacidad
        </v-card-title>
        <v-card-text class="text-body-2" style="max-height: 400px; overflow-y: auto;">
          <p>
            En MediCover nos tomamos tu privacidad muy en serio. Al realizar un pago en línea, tus datos personales y bancarios
            serán tratados con estricta confidencialidad, cumpliendo con la Ley Federal de Protección de Datos Personales.
          </p>
          <p>
            Utilizamos conexiones seguras (SSL) y pasarelas de pago certificadas para procesar tus pagos. No almacenamos información
            de tarjetas ni compartimos tus datos con terceros sin tu consentimiento.
          </p>
          <p>
            Si deseas más detalles sobre el manejo de tu información o ejercer tus derechos ARCO, puedes consultar nuestra política
            completa en el sitio web oficial o contactarnos directamente.
          </p>
          <p>
            Al continuar, reconoces que has leído y aceptas estos términos de privacidad.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="dialog = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "PoliticaPrivacidadPago",
  data() {
    return {
      dialog: false,
    };
  },
};
</script>
